import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function GithubCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    if (token) {
      localStorage.setItem('authToken', token);
      navigate('/');  // Redirect to the main page after login
    }
  }, [navigate]);

  return (
    <div>
      Processing GitHub login...
    </div>
  );
}

export default GithubCallback;